export const appName = "EpicWolverine's Heardle"